// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1swJh","boxTitle":"Qualiphy_boxTitle__30wvh","box":"Qualiphy_box__QILKB","toggleWrap":"Qualiphy_toggleWrap__2NNg8"};